import { render, staticRenderFns } from "./DashboardNyx.vue?vue&type=template&id=155458f4&scoped=true&"
import script from "./DashboardNyx.vue?vue&type=script&lang=js&"
export * from "./DashboardNyx.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNyx.vue?vue&type=style&index=0&id=155458f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155458f4",
  null
  
)

export default component.exports